module.exports = __webpack_public_path__ + "img/wallet.13e69122.svg";